import * as actions from '../actions/wordingCategories';
import * as ActionTypes from '../actions/index';
import xs from 'xstream';
import BASE_URL from './variables';

const REQUEST_WORDING_CATEGORIES = 'requestWordingCategories';

export function requestWordingCategories(sources) {

    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.FETCH_WORDING_CATEGORIES)
        .map(action => ({
            url: BASE_URL + 'api/WordingCategories',
            category: REQUEST_WORDING_CATEGORIES,
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select(REQUEST_WORDING_CATEGORIES)
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .map(response => (
            response.status === 200
                ? actions.fetchWordingCategoriesSuccess(response)
                : actions.fetchWordingCategoriesFailed(response)
        ));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}
